/**
 * 將字串進行 HTML escape，防止 XSS 注入
 * @param unsafe 字串
 * @returns 已 escape 的安全字串
 */
export function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
